

















































import Vue, { DirectiveOptions } from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

export interface MultiselectItem {
  name: string;
  value: number | string;
}

@Component({})
export class TagMultiselect extends Vue {
  public get unselectedItems(): MultiselectItem[] {
    return this.items.filter(
      item => this.selectedValues.indexOf(item.value) < 0
    );
  }

  public get selectedItems(): MultiselectItem[] {
    return this.items.filter(
      item => this.selectedValues.indexOf(item.value) > -1
    );
  }

  public get filteredItems(): MultiselectItem[] {
    if (!this.unselectedItems) {
      return [];
    } else if (!this.searchText) {
      return this.unselectedItems;
    }

    return this.unselectedItems.filter(item =>
      new RegExp(this.searchText, 'gi').test(item.name)
    );
  }
  @Prop({ required: false, default: 'Search...' })
  public searchPlaceholderText!: string;

  @Prop({ required: false, default: null })
  public loadingText!: string | null;

  @Prop({ required: true })
  public items!: MultiselectItem[];

  @Prop({ required: false })
  public clear!: boolean;

  @Prop({ required: true })
  public clickOutside!: boolean;

  public showDropdown: boolean = true;

  private searchText: string = '';
  private selectedValues: Array<string | number> = [];

  public onItemAdded(item: MultiselectItem): void {
    this.selectedValues = [...(this.selectedValues || []), item.value];
    this.$emit('onItemsChanged', this.selectedValues);
  }

  public onItemRemoved(item: MultiselectItem): void {
    this.selectedValues = this.selectedValues.filter(v => v !== item.value);
    this.$emit('onItemsChanged', this.selectedValues);
  }

  @Watch('clickOutside')
  public onClickOutside(val: boolean) {
    if (val) {
      this.showDropdown = false;
      this.searchText = '';
    }
  }

  @Watch('clear')
  public onClear() {
    this.selectedValues = [];
  }
}

export default TagMultiselect;
